var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-r options"},_vm._l((_vm.options),function(option,index){return _c('span',{key:index,class:[
      'd-flex d-flex-c d-flex-center mr-2 option',
      { 'is-selected': index === _vm.selectedIndex },
    ],on:{"click":() => _vm.selectOption(index)}},[_vm._v(_vm._s(option))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }